import { generateUUID } from '@wix/form-schema';
const ADDRESS_TARGETS = [
    'country',
    'subdivision',
    'city',
    'addressLine',
    'addressLine2',
    'postalCode',
    'streetName',
    'streetNumber',
    'apartment',
];
const overrideTemplateIds = (template, newFieldIds) => {
    const newIdsMapping = template.fields?.reduce((result, field) => {
        if (field.id && field.target) {
            result[field.id] = newFieldIds[field.target];
            return result;
        }
        return result;
    }, {});
    const fields = template.fields?.map((field) => ({
        ...field,
        id: field.id && newIdsMapping[field.id],
    }));
    const steps = template.steps?.map((step) => {
        return {
            ...step,
            layout: {
                ...step.layout,
                large: {
                    ...step.layout?.large,
                    items: step.layout?.large?.items?.map((item) => ({
                        ...item,
                        fieldId: item.fieldId && newIdsMapping[item.fieldId],
                    })),
                },
            },
        };
    });
    return { ...template, fields, steps };
};
export const overrideTemplateFieldIds = (templates) => {
    const newFieldIds = {};
    Object.values(ADDRESS_TARGETS).forEach((target) => {
        newFieldIds[target] = generateUUID();
    });
    return templates.map((template) => overrideTemplateIds(template, newFieldIds));
};
//# sourceMappingURL=address-forms-overrides.js.map